module.exports = __webpack_public_path__ + "img/tcf_2.c1c8ae02.png";